jQuery(document).ready(function ($) {
  $(document).on('click', '.fb-btn', function (e) {
    e.preventDefault();

    const url = window.location.href;

    const skeleton =
      '<div id="skeleton'+ $(this).data('id') +'"><div class="skeleton"><div class="skeleton-fb-img"></div><div class="row" style="flex-direction: column;"><div class="skeleton-fb-name"></div><div class="skeleton-fb-text"></div></div></div><div class="skeleton mt-2"><div class="skeleton-fb-img"></div><div class="row" style="flex-direction: column;"><div class="skeleton-fb-name"></div><div class="skeleton-fb-text"></div></div></div><div class="skeleton mt-2"><div class="skeleton-fb-img"></div><div class="row" style="flex-direction: column;"><div class="skeleton-fb-name"></div><div class="skeleton-fb-text"></div></div></div></div>';

    const fb_comments =
      '<div id="' + $(this).data('id') +  '" class="fb-comments" data-href="'+ url +'" data-numposts="10" data-colorscheme="light" data-width="100%"></div>';

    const html = skeleton + fb_comments;

    $(this).replaceWith(html);

    observer($(this).data('id'));

    FB.XFBML.parse();
  })

  function observer(id) {
    var target = document.getElementById(id);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if ($('#'+id).attr('fb-xfbml-state') == 'rendered') {
          var node = document.getElementById( 'skeleton'+id);
          if(node != null){
            node.parentNode.removeChild(node);
          }
        }
      });
    });

    var config = { attributes: true, childList: true, characterData: true, subtree: true };

    observer.observe(target, config);
  }

});
